import { signal } from "@angular/core";
import { Desktop, Help, Language, Profile } from "../interface/desktop-model";
import { AVAILABLE_LANGUAGES } from "../settings/settings.service";


// Readonly signals for static data
  export const HelpData = signal<Help[]>([
      { code: 'terms', name: 'Terms of Service', flag: '📜' },
      { code: 'privacy', name: 'Privacy Policy', flag: '🔒' },
      { code: 'cookies', name: 'Cookie Policy', flag: '🍪' }
  ]);

  export const ProfileData = signal<Profile[]>([
      { code: 'profile', name: 'Profile', flag: '👤' },
      { code: 'settings', name: 'Settings', flag: '⚙️' },
      { code: 'logout', name: 'Logout', flag: '👋' }
  ]);

  // Use centralized language data from settings service
  export const LanguageData = signal<Language[]>(AVAILABLE_LANGUAGES);

    export const DesktopData = signal<Desktop[]>([
        { id: 1, ref: 'desktopOne', name: 'Desktop 1', url: '/assets/wallpapers/1081111.jpg' },
        { id: 2, ref: 'desktopTwo', name: 'Desktop 2', url: '/assets/wallpapers/3996534.jpg' },
        { id: 3, ref: 'desktopThree', name: 'Desktop 3', url: '/assets/wallpapers/6249396.jpg' },
        { id: 4, ref: 'desktopFour', name: 'Desktop 4', url: '/assets/wallpapers/3426361.jpg' }
    ]);
